import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';

@Component({
  selector: 'app-specialist-verification',
  templateUrl: './specialist-verification.component.html',
  styleUrls: ['./specialist-verification.component.css']
})

export class SpecialistVerificationComponent {
  @ViewChild('detailsDialogTemplate') detailsDialogTemplate: TemplateRef<any>;

  isSubmitDisabled = false;
  strMobile = '';
  tankerProfile = null;
  unSubscribeAll$ = new Subject<void>();
  formGroup = new FormGroup({
    bInstallment: new FormControl(false),
    strPaymentComment: new FormControl(''),
    bCanEdit: new FormControl(false),
    iTrackingCode: new FormControl(''),
    iPayment1: new FormControl(''),
  });

  constructor(
    private accountService: AccountService,
    private otherService: OtherService,
    private ngbModal: NgbModal,
    private router: Router,
  ) { }

  submit(strMobileField: NgModel) {
    if (strMobileField.invalid || strMobileField.pristine || this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;
    this.tankerProfile = null;

    const model = {
      strMobile: this.strMobile,
      iSystemUser: this.otherService.specialistUser.iSystemUser,
      strSession: this.otherService.specialistUser.strSession
    };

    this.accountService.specialistCheckMobile(model).pipe(catchError(() => of(false)), takeUntil(this.unSubscribeAll$)).subscribe((response: string | false) => {
      this.isSubmitDisabled = false;

      if (response) {
        let result = JSON.parse(response);
        result = result[0];


        if (!result) {
          this.router.navigate(['/specialist-registration'], { queryParams: { mobile: this.strMobile } });
          return;
        }

        if (result?.ISSessionExpired == true) {
          this.otherService.logout();
          this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
          this.accountService.toastSwal('error', 'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید')
          return;
        }

        if (result.iResult === 0) {
          return this.accountService.toastSwal('error', result.strError);
        }

        this.tankerProfile = result;

        this.formGroup.patchValue({
          bInstallment: result?.bInstallment,
          strPaymentComment: result?.strPaymentComment,
          bCanEdit: result?.bCanEdit,
          iTrackingCode: result?.iTrackingCode,
          iPayment1: result?.iPayment1 > 0 ? result?.iPayment1.toLocaleString() : '',
        })

        if (!result?.bCanEdit) {
          // this.formGroup.get('bInstallment')?.disable();
          this.formGroup.disable();
        } else {
          // this.formGroup.get('bInstallment')?.enable();
          this.formGroup.enable();
        }

        this.openDetailsDialog();
        this.accountService.toastSwal('success', `عملیات با موفقیت انجام شد`);
      } else {
        this.accountService.toastSwal('error', 'خطایی رخ داد');
      }
    });
  }

  openDetailsDialog(): void {
    this.ngbModal.open(this.detailsDialogTemplate, {
      scrollable: true,
      container: 'app-specialist-verification',
      modalDialogClass: 'details-dialog',
      centered: true,
      animation: false
    });
  }

  submitForm() {
    if (!this.formGroup.value.bCanEdit) {
      return;
    }

    if (this.formGroup.value.iTrackingCode > 0 && !this.formGroup.value.iPayment1) {
      this.markAllAsTouched(this.formGroup);
      return this.accountService.toastSwal('error', 'مبلغ واریزی را وارد کنید!');
    }

    if (this.formGroup.value.bInstallment && !this.formGroup.value.strPaymentComment) {
      this.markAllAsTouched(this.formGroup);
      return this.accountService.toastSwal('error', 'توضیحات شرایط پرداخت را وارد کنید!');
    }

    const model = this.otherService.stringNumberToNumber({
      iSystemUser: this.otherService.specialistUser.iSystemUser,
      strSession: this.otherService.specialistUser.strSession,
      iPreregistration: this.tankerProfile?.iPreregistration,
      ...this.formGroup.value
    });

    this.accountService.preregistrationSetCode2(model).pipe(catchError(() => of(false)), takeUntil(this.unSubscribeAll$),).subscribe((response: string | false) => {
      if (response) {
        let result = JSON.parse(response);
        if (Array.isArray(result)) result = result[0];

        if (result?.ISSessionExpired == true) {
          this.otherService.logout();
          this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
          this.accountService.toastSwal('error', 'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید')
          return;
        }

        if (result.iResult === 0) {
          return this.accountService.toastSwal('error', result.strError);
        }

        this.accountService.toastSwal('success', result.strError);
        this.ngbModal.dismissAll('');
      }

      else {
        this.accountService.toastSwal('error', 'خطایی رخ داد');
      }
    });
  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUnTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: false });
      } else if (control instanceof FormGroup) {
        this.markAllAsUnTouched(control);
      }
    });
  }

  unSubscribeAll(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  ngOnDestroy(): void {
    this.unSubscribeAll();
  }

}